/**
 * Diamond amounts are fractional.
 *
 * The backend awards credits/5 rounded to 2 decimal places (no flooring), so a
 * balance or transaction amount can be 5.6 or 0.4 — never assume an integer.
 * Kept in sync with Backend/src/config/constants.ts (services share no code).
 */

const DIAMOND_ROUNDING_FACTOR = 100;

/** Round a diamond amount to 2 decimal places. */
export function roundDiamonds(value: number): number {
  return Math.round(value * DIAMOND_ROUNDING_FACTOR) / DIAMOND_ROUNDING_FACTOR;
}

/**
 * Format a diamond amount for display: thousands separators, at most 2 decimal
 * places, and no trailing zeros — 1200 reads as "1,200", 1200.5 as "1,200.5".
 */
export function formatDiamonds(value: number): string {
  return roundDiamonds(value).toLocaleString(undefined, { maximumFractionDigits: 2 });
}
